
const m = window.require("bootbox");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
